import _ from 'lodash'
import { c } from '../../lib/const'
import { api } from '../../lib/api'
import { toNum, toStr, getMonthName, dateFormat, linkify } from '../../js/common'
import { systemComment, systemIcon } from '../../js/pr.js'
import { mixinLists } from './lists.js'

var mixinOrder = {
	data: function () {
		return {
			order: {
				show: false,
				supplier: '',
				headers: [
					{
						value: 'num',
						text: '№',
						align: 'center'
					},
					{
						value: 'name',
						text: 'Наименование товаров / услуг',
						align: 'center'
					},
					{
						value: 'sumNet',
						text: 'Сумма без НДС',
						align: 'center',
						width: 150,
					},
					{
						value: 'sumGross',
						text: 'Сумма с НДС',
						align: 'center',
						width: 150,
					},
					{
						value: 'sumGrossPre',
						text: 'Сумма с НДС к предоплате',
						align: 'center',
						width: 150,
					},
					{
						value: 'preOrder',
						text: 'Ордер на предоплату',
						align: 'center'
					},
					{
						value: 'sumGrossPost',
						text: 'Сумма с НДС к постоплате',
						align: 'center',
						width: 150,
					},
					{
						value: 'postOrder',
						text: 'Ордер на постоплату',
						align: 'center'
					},
				],
				selected: [],
				uploadedFiles: [],
				files: [],
				editFiles: false,
				editGross: false,
				method: '',
			},
		}
	},
	computed: {
		orderAppendColspanLeft() {
			return 1 + 1 * (this.order.method != 'show')
		},
		orderAppendColspanRight() {
			if (this.prepayPercent == 100 || this.prepayPercent == 0) return 1
			else return 4
		},
		orderComputedHeaders() {
			let headers = _.cloneDeep(this.order.headers)

			if (this.prepayPercent == 0) {
				headers.splice(4, 3)
				// headers[3].text = 'Сумма с НДС'
				headers[4].text = 'Ордер на оплату'
			}
			else if (this.prepayPercent == 100) {
				headers.splice(4, 1)
				headers.splice(5, 2)
				// headers[3].text = 'Сумма с НДС'
				headers[4].text = 'Ордер на оплату'
			}
			else if (this.order.method == 'pre') {
				headers.splice(6, 2)
			}

			if (this.order.method == 'show'
				&& this.pr.qSelected > 0
				&& this.pr.lines.some(l => l.qns[this.pr.qSelected - 1].sumGross == '0.00')
			) {
				headers = headers.filter(h => (
					h.value != 'sumGross'
					&& h.value != 'sumGrossPre'
					&& h.value != 'sumGrossPost'
				))
			}

			return headers
		},
		orderCreatedShow() {
			if (this.order.method == 'show') return true
			else if (!this.pr.qSelected) return false
			else return this.pr.lines.some(line => line[this.order.method + 'OrderId'])
		},
		orderCreatedSumNet() {
			if (!this.pr.qSelected) return 0
			else return toStr(this.pr.lines.reduce((acc, cur) => {
				if (cur[this.order.method + 'OrderId']) return acc + toNum(cur.qns[this.pr.qSelected - 1].sumNet)
				else return acc
			}, 0))
		},
		orderCreatedSumGrossPre() {
			if (!this.pr.qSelected) return 0
			else return toStr(this.pr.lines.reduce((acc, cur) => {
				if (cur.preOrderId) return acc + toNum(cur.qns[this.pr.qSelected - 1].sumGross) * this.prepayPercent / 100
				else return acc
			}, 0))
		},
		orderCreatedSumGrossPost() {
			if (!this.pr.qSelected) return 0
			else return toStr(this.pr.lines.reduce((acc, cur) => {
				if (cur.postOrderId) return acc + toNum(cur.qns[this.pr.qSelected - 1].sumGross) * this.postpayPercent / 100
				else return acc
			}, 0))
		},
		orderSelectedLineIds() {
			return this.orderSelectedLines.map(line => line.id).filter(id => !!id)
		},
		orderSelectedLines() {
			return this.order.selected.filter(line => line[this.order.method + 'OrderId'] == 0)
		},
		orderSumGross() {
			if (!this.pr.qSelected) return 0
			else return toStr(this.orderSelectedLines.reduce((acc, cur) => {
				return acc + toNum(cur.qns[this.pr.qSelected - 1].sumGross)
			}, 0))
		},
		orderSumGrossError() {
			// + 1 - для учета погрешности при суммировании сумм с НДС
			return toNum(this.orderSumGross) + toNum(this.orderCreatedSumGross) > toNum(this.pr.sumGross) + 1
		},
		orderSumNet() {
			if (!this.pr.qSelected) return 0
			else return toStr(this.orderSelectedLines.reduce((acc, cur) => {
				return acc + toNum(cur.qns[this.pr.qSelected - 1].sumNet)
			}, 0))
		},
		orderSumGrossPre() {
			return toStr(toNum(this.orderSumGross) * this.prepayPercent / 100)
		},
		orderSumGrossPost() {
			return toStr(toNum(this.orderSumGross) * this.postpayPercent / 100)
		},
	},
	methods: {
		createOrder(approve) {
			if (approve === undefined) approve = false
			this.loading = true

			var formData = new FormData()

			let l = this.order.uploadedFiles.length
			// console.log('uploaded files: ' + l)
			for (let j = 0; j < l; j++) {
				// console.log('- uploaded file j:')
				// console.log(this.order.uploadedFiles[j])
			}

			let m = this.order.files.length
			// console.log('new files: ' + m)
			for (let j = 0; j < m; j++) {
				formData.append('files[]', this.order.files[j])
				// console.log('- new file j:')
				// console.log(this.order.files[j])
			}

			formData.append('form', JSON.stringify({
				prId: this.pr.id,
				hotelCode: this.pr.hotelCode,
				supplier: this.order.supplier,
				lines: this.orderSelectedLines,
				method: this.order.method,
				uploadedFiles: this.order.uploadedFiles,
				approve: approve
			}))

			// for (var pair of formData.entries()) {
			// 	console.table(pair[0] + ', ' + pair[1])
			// }

			api.post('po/create', formData)
			.then(response => {

				// console.log(this.orderSelectedLines)

				this.orderSelectedLines.forEach(line => {
					line[this.order.method + 'OrderId'] = response.data.id
				})

				// console.log(this.orderSelectedLines)

				this.order.show = false
				this.order.editGross = false

				this.loading = false

				this.pr.buttons = response.data.buttons
				this.pr.status = response.data.status

				this.loadComments()

				this.showSnackInfo(response.data.sysComment)

			}, error => {
				this.loading = false
				this.order.show = false
				this.order.editGross = false
			})
		},
		orderClose() {
			this.order.show = false
			this.order.editGross = false
		},
		orderOpen(method) {
			// method:
			// 	- show
			//	- pre
			//	- post

			this.order.show = true
			this.order.supplier = this.pr.qns[this.pr.qSelected - 1].name
			this.order.selected = this.pr.lines
			this.order.editFiles = false
			this.order.uploadedFiles = _.cloneDeep(this.pr.files[this.pr.qSelected])
										.concat(_.cloneDeep(this.pr.files[0]))
			this.order.method = method

			if (method == 'show') {
				this.order.editGross = false
			}
			else {
				let q = this.pr.qSelected - 1

				let vatPercent = this.pr.sumGross / this.pr.sumNet * 100 - 100
				vatPercent = vatPercent.toFixed(2)

				if (vatPercent == this.vat || vatPercent == 0) {
					this.order.editGross = false
				}
				else {
					this.order.editGross = true
				}

				this.pr.lines.forEach(line => {
					if (!line.preOrderId && !line.postOrderId) {
						if (vatPercent == this.vat) {
							line.qns[q].sumGross = toStr(toNum(line.qns[q].sumNet) * (1 + this.vat / 100))
						}
						else {
							line.qns[q].sumGross = line.qns[q].sumNet
						}
					}
				})
			}
		},
	},
}
var mixinChart = {
	computed: {
		chartMonthMax() {
			return Math.max(+this.pr.prFact + +this.chartSum, +this.pr.monthBudget)
		},
		chartMonthFact() {
			return (+this.pr.prFact + +this.chartSum) / this.chartMonthMax / 1.1 * 100
		},
		chartMonthBudget() {
			return (+this.pr.monthBudget) / this.chartMonthMax / 1.1 * 100
		},
		chartSum() {
			let sum = 0
			if (this.pr.sumNet) {
				sum = this.pr.sumNet
			}
			else {
				sum = this.minSumNet
			}

			if (this.pr.hotelCode == 'SBCU') {
				// Для SBCU выводим график с НДС
				sum = sum * (1 + c.VAT / 100)
			}

			return sum
		},
		chartYearMax() {
			return Math.max(+this.pr.plFact + this.pr.prFact + +this.chartSum, +this.pr.ytdBudget)
		},
		chartYearFactPl() {
			return (+this.pr.plFact) / this.chartYearMax * 100
		},
		chartYearFact() {
			return (+this.pr.plFact + this.pr.prFact + +this.chartSum) / this.chartYearMax * 100
		},
		chartYearBudget() {
			return (+this.pr.ytdBudget) / this.chartYearMax * 100
		},
		expensesMonthFact() {
			return toStr(+this.pr.prFact + +this.chartSum, 0)
		},
		expensesMonthBudget() {
			return toStr(+this.pr.monthBudget, 0)
		},
		expensesYearFact() {
			return toStr(+this.pr.plFact + this.pr.prFact + +this.chartSum, 0)
		},
		expensesYearFactPl() {
			return toStr(+this.pr.plFact, 0)
		},
		expensesYearFactPr() {
			return toStr(+this.pr.prFact + +this.chartSum, 0)
		},
		expensesYearBudget() {
			return toStr(+this.pr.ytdBudget, 0)
		},
	},
}
var mixinSnack = {
	data: function () {
		return {
			snack: {
				vat: {
					show: false,
					item: null,
					i: 0,
					field: '',
				},
				info: {
					show: false,
					message: '',
					icon: {
						name: '',
						color: ''
					},
				},
				orderGross: {
					show: false,
					item: null,
				},
				payroll: {
					show: false
				},
				totalGross: {
					show: false,
					i: 0,
				},
				totalPrepay: {
					show: false,
					i: 0,
				},
			},
		}
	},
	methods: {
		deductVat() {
			this.$refs['line' + this.snack.vat.item.num].$refs['q' + this.snack.vat.i][0].deductVat(this.snack.vat.field)
		},
		hideSnackVat() {
			// console.log('hidesnack.vat')

			this.snack.vat.show = false
			this.snack.vat.item = null
			this.snack.vat.field = ''
			this.snack.vat.i = 0
		},
		hideSnackTotalPrepay() {
			this.snack.totalPrepay.i = 0
			this.snack.totalPrepay.show = false
		},
		hideSnackTotalGross() {
			this.snack.totalGross.i = 0
			this.snack.totalGross.show = false
		},
		hideSnackOrderGross() {
			this.snack.orderGross.i = 0
			this.snack.orderGross.show = false
		},
		hideSnackTotalPayroll() {
			this.snack.payroll.show = false
		},
		orderSetVat(val) {
			let q = this.snack.orderGross.item.qns[this.pr.qSelected - 1]

			q.sumGross = toStr(toNum(q.sumNet) * (1 + val / 100))
		},
		prepaySet(val) {
			let index = this.snack.totalPrepay.i - 1
			this.$refs.prepay[index].percentChange(val)
		},
		showSnackInfo(action) {
			this.snack.info.show = false

			this.snack.info.message = systemComment(action)
			this.snack.info.icon = systemIcon(action)
			this.snack.info.show = true
		},
		showSnackOrderGross(item) {
			this.snack.orderGross.item = item
			this.snack.orderGross.show = true
		},
		showSnackTotalPrepay(i) {
			this.snack.totalPrepay.i = i
			this.snack.totalPrepay.show = true
		},
		showSnackTotalGross(i) {
			this.snack.totalGross.i = i
			this.snack.totalGross.show = true
		},
		showSnackTotalPayroll() {
			this.snack.payroll.show = true
		},
		showSnackVat(item, i, field) {
			// console.log('showsnack.vat', item, i , field)

			this.snack.vat.item = item,
			this.snack.vat.i = i
			this.snack.vat.field = field
			this.snack.vat.show = true
		},
		totalSetVat(val) {
			let index = this.snack.totalGross.i - 1
			this.$refs.totalGross[index].percentChange(val)
		},
	}
}
var mixinSplit = {
	data: function () {
		return {
			split: {
				show: false,
				selected: [],
			},
		}
	},
	computed: {
		splitComputedHeaders() {
			return this.computedHeaders.filter(h => {
				return h.value != 'chars'
			})
		}
	},
	methods: {
		makeSplit() {
			api.post('pr/split', {
				id: this.pr.id,
				rows: this.split.selected.map(row => row.id)
			})
			.then(response => {
				this.load()
				this.$store.dispatch('dialogNotify', {
					title: 'Заявка разделена',
					message: 'Создана новая заявка '
						+ `<router-link :to="{ name: 'PrEntry', params: { id: ${response.data.splitId} } }">`
						+ `${response.data.splitId}`
						+ '</router-link>'
				})
				this.splitClose()
			}, error => {})
		},
		splitClose() {
			this.split.show = false
		},
		splitOpen() {
			this.topMenu = false
			this.split.show = true
		},
		splitClickRow(row) {
			let i = this.split.selected.indexOf(row)
			if (i > -1) {
				this.split.selected.splice(i, 1)
			}
			else {
				this.split.selected.push(row)
			}
		}
	},
}

export const mixinEntryScript = {
	mixins: [
		mixinOrder,
		mixinChart,
		mixinSnack,
		mixinLists,
		mixinSplit
	],
	data: () => ({
		commentsB: '',
		editMode: false,
		editQnsMode: false,
		editIcMode: false,
		deliveryDateMenu: false,
		draftMode: false,	// устанавливается в true только про методе clone()
		expandBudget: false,
		files: [
			[],
			[],
			[],
			[],
		],
		filters: [],
		headers: [
			{
				q: 0,
				type: '',
				value: 'num',
				align: 'center',
				text: '№'
			},
			{
				q: 0,
				type: '',
				value: 'name',
				align: 'center',
				text: 'Наименование товаров / услуг'
			},
			{
				q: 0,
				type: '',
				value: 'chars',
				align: 'center',
				text: 'Характеристики / ссылка'
			},
			{
				q: 0,
				type: '',
				value: 'unit',
				align: 'center',
				text: 'Ед. изм.'
			},
			{
				q: 0,
				type: '',
				value: 'qty',
				align: 'center',
				text: 'Кол-во'
			},
			{
				q: 1,
				type: 'quotation',
				value: 'q1'
			},
			{
				q: 2,
				type: 'quotation',
				value: 'q2'
			},
			{
				q: 3,
				type: 'quotation',
				value: 'q3'
			},
		],
		intersectingButtons: false,
		intersectingComments: false,
		loading: false,
		valid: false,
		payrollTax: c.PAYROLL_TAX,
		personalTax: c.PERSONAL_TAX,
		pr: {
			id: 0,
			loading: false,
			status: 0,
			hotelCode: '',
			budget: 1,
			dc: 0,
			dcn: '',
			ic: 0,
			icn: '',
			stamps: [],
			title: '',
			type: 1,
			mmId: 0,
			deliveryDate: '',
			urgent: 0,
			lines: [
				{
					chars: '',
					delivery: 0,
					preOrderId: 0,
					postOrderId: 0,
					mmId: 0,
					mmLineId : 0,
					name: '',
					num: 1,
					qns: [
						{
							sumNet: 0,
						},
						{
							sumNet: 0,
						},
						{
							sumNet: 0,
						},
					],
					qty: '',
					unit: ''
				}
			],
			comments: [],
			files: [
				[],
				[],
				[],
				[]
			],
			uniqueSupplier: 0,
			fcCommand: 0,
			qSelected: 0,
			qns: [
				{
					visible: true,
					name: '',
					sumGross: '',
					prepay: '',
					cash: false,
					deliveryBasis: '',
					deliveryDate: '',
				},
				{
					visible: false,
					name: '',
					sumGross: '',
					prepay: '',
					cash: false,
					deliveryBasis: '',
					deliveryDate: '',
				},
				{
					visible: false,
					name: '',
					sumGross: '',
					prepay: '',
					cash: false,
					deliveryBasis: '',
					deliveryDate: '',
				},
			],
			minSumNet: 0,
			maxSumNet: 0,
			commentsA: '',
			commentsB: '',
			authorName: '',
			createdDate: '',
			buttons: [],
			qnsListingRequired: 0,
			qnsSelectRequired: 0,
			monthBudget: '',
			qtdBudget: '',
			ytdBudget: '',
			plFact: '',
			prFact: '',
			nextPr: '',
			sumNet: 0,
			sumGross: '',
			prepay: '',
			to_pay: '',
			steps: [],
		},
		printComments: false,
		rules: {
			required: v => !!v || 'Обязательное поле',
		},
		search: '',
		showErrors: false,
		showDetails: false,
		showChanges: false,
		timer: 0,
		topMenu: false,
		updateInterval: 300000,	// 5 минут
		vat: c.VAT,
		qSelected: 0,
		qSelectError: false,
	}),
	computed: {
		assumedCash() {
			if (this.pr.type == 3) return true
			else if (this.pr.qSelected > 0) {
				return this.qnsCash[this.pr.qSelected]
			}
			else {
				return this.qMin.cash
			}
		},
		budgetName() {
			return this.lists.budget.find(el => el.value == this.pr.budget).text
		},
		commentsAComputed() {
			return linkify(this.pr.commentsA.replace(/\n/gi, '<br>'))
		},
		commentsBComputed() {
			return linkify(this.pr.commentsB.replace(/\n/gi, '<br>'))
		},
		commentsBRules() {
			if (this.qSelected == 0) return []
			else if (this.qnsSumNet[this.qSelected - 1] > this.minSumNet) {
				return [ v => !!v || 'Обязательно, если выбрано предложение с не наименьшей ценой' ]
			}
			else return []
		},
		computedHeaders() {
			let h = this.headers.filter(header => {
				if (header.q == 0) {
					if (this.pr.type == 4) {
						if (header.value == 'num' || header.value == 'name') return true
						else return false
					}
					else {
						return true
					}
				}
				else return this.pr.qns[header.q - 1].visible
			})

			if (this.pr.type == 4) {
				h[1].text = 'Сотрудник'
			}

			if (this.editMode || this.editQnsMode) {
				h.push({
					q: 0,
					type: 'actions',
					value: 'actions'
				})
			}

			return h
		},
		createdDateFormatted() {
			return dateFormat(this.pr.createdDate)
		},
		dc() {
			// нужно для навешивания watch
			return this.pr.dc
		},
		dcName() {
			if (this.lists.dc.length == 0 || !this.dc) return ''
			else return this.lists.dc.find(el => el.code == this.pr.dc).name
		},
		deliveryBasisName() {
			return this.pr.qns.map(q => {
				if (!q.deliveryBasis) return ''
				else return this.lists.deliveryBasis.find(el => el.value == q.deliveryBasis).text
			})
		},
		deliveryDate() {
			// нужно для навешивания watch
			return this.pr.deliveryDate
		},
		deliveryDateFormatted() {
			return dateFormat(this.pr.deliveryDate)
		},
		deliveryInLines() {
			return this.pr.lines.some(line => +line.delivery)
		},
		deliveryMonth() {
			return getMonthName(new Date(this.pr.deliveryDate).getMonth() + 1)
		},
		hotelCode() {
			// нужно для навешивания watch
			return this.pr.hotelCode
		},
		ic() {
			// нужно для навешивания watch
			return this.pr.ic
		},
		icName() {
			if (this.lists.ic.length == 0) return ''
			else {
				let ic = this.lists.ic.find(el => el.code == this.pr.ic)
				if (ic) return ic.name
				else return ''
			}
		},
		minSumNet() {
			return this.qnsSumNet[this.qMinIndex]
		},
		postpayPercent() {
			return 100 - this.prepayPercent
		},
		prepayPercent() {
			return this.pr.prepay / this.pr.sumGross * 100
		},
		selectHotel() {
			return this.$store.getters.availableHotels
		},
		type() {
			// нужно для навешивания watch
			return this.pr.type
		},
		typeName() {
			let t = this.lists.type.find(el => el.value == this.pr.type)
			if (t === undefined) return ''
			else return t.text
		},
		typeListComputed() {
			if (this.pr.type == 5) {
				return this.lists.type
			}
			else {
				return this.lists.type.filter(t => t.value != 5)
			}
		},
		urgentName() {
			return this.lists.urgent.find(el => el.value == this.pr.urgent).text
		},
		viewMode() {
			return !this.editMode
				&& !this.editQnsMode
				&& !this.editIcMode
		},
		visible() {
			return this.pr.qns.map(q => q.visible)
		},
		qMinIndex() {
			return this.qnsSumNet.reduce((acc, cur, i) => {
				if (cur > 0 && cur < acc.sum) {
					acc.q = i
					acc.sum = cur
				}
				return acc
			}, {
				sum: Infinity,
				q: 0
			}).q
		},
		qMin() {
			return {
				sumNet: this.minSumNet,
				prepay: this.qnsPrepay[this.qMinIndex],
				cash: this.qnsCash[this.qMinIndex]
			}
		},
		qnsCash() {
			return this.pr.qns.map(v => v.cash)
		},
		qnsCount() {
			return this.pr.qns.reduce((acc, cur) => {
				if (cur.visible) {
					acc++
				}
				return acc
			}, 0)
		},
		qnsPrepay() {
			return this.pr.qns.map(v => toNum(v.prepay))
		},
		qnsSumNet() {
			let s = this.pr.lines.reduce((acc, cur) => {
				return [
					acc[0] + toNum(cur.qns[0].sumNet),
					acc[1] + toNum(cur.qns[1].sumNet),
					acc[2] + toNum(cur.qns[2].sumNet)
				]
			}, [ 0, 0, 0 ])

			return s
		},
		qnsSumGross() {
			return this.pr.qns.map(v => toNum(v.sumGross))
		},
	},
	created() {
		this.debouncedGetSteps = _.debounce(this.getSteps, 1000, { leading: false })
		this.debouncedGetDcList = _.debounce(this.getDcList, 2000, { leading: false })
		this.debouncedGetIcList = _.debounce(this.getIcList, 2000, { leading: false })
		this.debouncedGetIcListLeading = _.debounce(this.getIcList, 2000, { leading: true })
		this.debouncedGetChartParams = _.debounce(this.getChartParams, 2000, { leading: false })
		this.throttledLoad = _.throttle(this.load, 10000)
		this.throttledLoadComments = _.throttle(this.loadComments, 10000)
	},
	mounted() {
		this.pr.id = this.$route.params.id

		if (this.$route.params.search !== undefined) this.search = this.$route.params.search
		if (this.$route.params.filters !== undefined) this.filters = this.$route.params.filters
		if (this.$route.params.showAll !== undefined) this.showAll = this.$route.params.showAll
		if (this.$route.params.draftMode !== undefined) this.draftMode = this.$route.params.draftMode

		this.prepare()

		this.timer = setInterval(() => {
			// console.log('interval function')
			if (!document.hidden) {
				if (this.viewMode && !this.order.show) {
					this.throttledLoad()
				}
				this.throttledLoadComments()
			}
		}, this.updateInterval)

		// console.log(window.onfocus)

		window.onfocus = () => {
			// console.log('onfocus')
			if (this.viewMode && !this.order.show) {
				this.throttledLoad()
			}
			this.throttledLoadComments()
		}
	},
	destroyed() {
		clearInterval(this.timer)
		window.onfocus = null
	},
	watch: {
		editMode(val, old) {
			if (val) {
				// console.log('watcher - editMode', old, '=>', val)
				if (this.lists.dc.length <= 1) {
					this.debouncedGetDcList()
				}
				if (this.lists.ic.length <= 1) {
					this.debouncedGetIcList()
				}
			}
		},
		editIcMode(val, old) {
			if (val) {
				// console.log('watcher - editIcMode', old, '=>', val)
				if (this.lists.dc.length <= 1) {
					this.debouncedGetDcList()
				}
				if (this.lists.ic.length <= 1) {
					this.debouncedGetIcList()
				}
			}
		},
		dc(val, old) {
			if (!_.isEqual(val, old) && this.editMode) {
				// console.log('watcher - dc', old, '=>', val)

				this.debouncedGetIcListLeading()
				this.debouncedGetSteps()
				this.debouncedGetChartParams()
			}
		},
		ic(val, old) {
			if (!_.isEqual(val, old) && (this.editMode || this.editIcMode)) {
				// console.log('watcher - ic', old, '=>', val)
				this.debouncedGetSteps()
				this.debouncedGetChartParams()
			}
		},
		deliveryDate(val, old) {
			if (!_.isEqual(val, old) && this.editMode) {
				// console.log('watcher - deliveryDate', old, '=>', val)
				this.debouncedGetChartParams()
			}
		},
		hotelCode(val, old) {
			if (!_.isEqual(val, old) && this.editMode) {
				// console.log('watcher - hotelCode', old, '=>', val)
				// обновить Steps
				this.debouncedGetSteps()
				// обновить график бюджета
				this.debouncedGetChartParams()
			}
		},
		type(val, old) {
			if (!_.isEqual(val, old) && this.editMode) {
				// console.log('watcher - type', old, '=>', val)
				this.debouncedGetSteps()

				if (val == 3) {
					// не наличные => наличные
					this.pr.qns.forEach(q => { q.cash = true })
				}
				else if (old == 3) {
					// наличные => не наличные
					this.pr.qns.forEach(q => { q.cash = false })
				}
				else if (val == 4) {
					// не выплата сотрудникам => выплата сотрудникам
					this.deleteQuotation(1)
					this.deleteQuotation(2)

					for (let i = 1; i < 4; i++) {
						this.files[i].splice(0, this.files[i].length)
						this.pr.files[i].splice(0, this.pr.files[i].length)
					}

					this.pr.qns[0].name = ''
					this.pr.qns[0].sumGross = ''
					this.pr.qns[0].prepay = ''
					this.pr.qns[0].cash = false
					// this.pr.qns[0].deliveryCost = ''
					this.pr.qns[0].deliveryDate = ''
					this.pr.qns[0].deliveryBasis = ''

					this.pr.lines.forEach(l => {
						l.chars = ''
						l.unit = ''
						l.qty = ''
					})
				}
				else if (old == 4) {
					// выплата сотрудникам => не выплата сотрудникам
				}
			}
		},
		qMin(val, old) {
			if (!_.isEqual(val, old) && (this.editMode || this.editQnsMode)) {
				// console.log('watcher - qMin', old, '=>', val)
				// обновить Steps
				this.debouncedGetSteps()
			}
		},
	},
	methods: {
		actionController(value) {
			// console.log(value)
			if (value == 'edit') this.edit()
			else if (value == 'editQns') this.editQns()
			else if (value == 'editIc') this.editIc()
			else if (value == 'approve') this.confirmApprove()
			else if (value == 'withdraw') this.withdraw()
			else if (value == 'reject') this.reject()
			else if (value == 'drop') this.confirmDrop()
			else if (value == 'dropToPu') this.confirmDropToPu()
			else if (value == 'createOrderPre') this.orderOpen('pre')
			else if (value == 'createOrderPost') this.orderOpen('post')
			else if (value == 'showOrders') this.orderOpen('show')
			else if (value == 'delete') this.deletePr()
		},
		addQuotation() {
			let c = this.qnsCount

			this.pr.qns[c].visible = true
		},
		approve() {
			if (this.pr.qnsSelectRequired) {
				if (this.qSelected == 0) {
					this.qSelectError = true
				}

				if (!this.$refs.form.validate()) {
					this.showErrors = true
				}
			}

			this.startButtonLoading('approve')

			let params = {
				id: this.pr.id
			}

			if (this.pr.qnsSelectRequired) {
				params.qSelected = this.qSelected
				params.commentsB = this.commentsB
			}

			api.post('pr/approve', params)
			.then(response => {

				this.stopButtonLoading('approve')
				this.pr.buttons = response.data.buttons
				this.pr.status = response.data.status
				this.pr.qnsSelectRequired = response.data.qnsSelectRequired
				this.pr.qnsListingRequired = response.data.qnsListingRequired
				this.pr.qSelected = response.data.qSelected
				this.pr.cash = response.data.cash
				this.pr.sumNet = response.data.sumNet
				this.pr.sumGross = response.data.sumGross
				this.pr.prepay = response.data.prepay
				this.pr.commentsB = response.data.commentsB

				this.loadComments()

				this.qSelectError = false

				this.showSnackInfo(response.data.sysComment)

				this.$store.dispatch('loadMenuCounters')

			}, error => {
				this.stopButtonLoading('approve')
			})
		},
		back() {
			if (this.search.length || this.filters.length || this.showAll) {
				this.$router.push({
					name: 'PrList',
					params: {
						search: this.search,
						filters: this.filters,
						showAll: this.showAll
					}
				})
			}
			else {
				this.$router.push({
					name: 'PrList'
				})
			}
		},
		cancelEditing() {
			if (this.draftMode) {
				api.post('pr/delete', {
					id: this.pr.id
				})
				.then(response => {

					this.$router.push('/pr')

				}, error => {})
			}
			else if (this.pr.id == 0) {
				this.$router.push('/pr')
			}
			else {

				this.pr.lines.forEach(l => {
					// l.qty = ''
					l.qns.forEach((q, i) => {
						q.sumNet = ''
						// q.priceNet = ''
					})
				})
				this.pr.qns.forEach((q, i) => {
					q.sumGross = ''
					q.prepay = ''
					// q.deliveryCost = ''
				})

				this.files.forEach(f => {
					f.splice(0, f.length)
				})

				this.pr.files.forEach(f => {
					f.splice(0, f.length)
				})

				this.$refs.form.resetValidation()
				this.showErrors = false

				this.editMode = false
				this.editQnsMode = false
				this.editIcMode = false

				this.load()
			}
		},
		confirmApprove() {
			if (this.pr.buttons.find(b => b.value == 'createOrderPre').visible) {
				if (this.pr.lines.some(l => !l.preOrderId)) {
					this.$store.dispatch('dialogConfirm', {
						title: 'Вы уверены?',
						message: 'Не по всем строкам заявки были созданы ордера на предоплату. Если вы переведете заявку на следующий этап, вы не сможете потом создать другие ордера на предоплату.<br><br>Созданные вами ордера могут быть оплачены независимо от статуса текущей заявки.<br><br>Вы уверены, что создали все ордера на предоплату и заявку можно перевести на следующий этап?'
					})
					.then(confirm => {
						if (confirm) {
							this.approve()
						}
					})
				}
				else {
					this.approve()
				}
			}
			else if (this.pr.buttons.find(b => b.value == 'createOrderPost').visible) {
				if (this.pr.lines.some(l => !l.postOrderId)) {
					this.$store.dispatch('dialogConfirm', {
						title: 'Вы уверены',
						message: 'Не по всем строкам заявки были созданы ордера на постоплату. Если вы переведете заявку на следующий этап, вы не сможете потом создать другие ордера на постоплату.<br><br>Созданные вами ордера могут быть оплачены независимо от статуса текущей заявки.<br><br>Вы уверены, что создали все ордера на постоплату и заявку можно перевести на следующий этап?'
					})
					.then(confirm => {
						if (confirm) {
							this.approve()
						}
					})
				}
				else {
					this.approve()
				}
			}
			else {
				this.approve()
			}
		},
		confirmDeleteQuotation(i) {
			if (this.qnsSumNet[i] == 0) {
				this.deleteQuotation(i)
			}
			else {
				this.$store.dispatch('dialogConfirm', {
					title: 'Подтвердите удаление',
					message: 'Вы действительно хотите удалить предложение от ' + this.pr.qns[i].name + '?'
				})
				.then(confirm => {
					if (confirm) {
						this.deleteQuotation(i)
					}
				})
			}
		},
		confirmDrop() {
			this.$store.dispatch('dialogConfirm', {
				title: 'Подтвердите сброс согласований',
				message: 'Вы действительно сбросить все согласования?'
			})
			.then(confirm => {
				if (confirm) {
					this.drop()
				}
			})
		},
		confirmDropToPu() {
			this.$store.dispatch('dialogConfirm', {
				title: 'Подтвердите сброс согласований',
				message: 'Вы действительно сбросить все согласования после отдела закупок?'
			})
			.then(confirm => {
				if (confirm) {
					this.dropToPu()
				}
			})
		},
		clone() {
			this.topMenu = false

			// console.log('clone')
			api.post('pr/clone', {
				id: this.pr.id
			}).then(response => {

				this.editMode = true

				this.$router.push({ name: 'PrEntry', params: { id: response.data.cloneId, draftMode: true } })

			}, error => {})
		},
		deletePr() {
			this.$store.dispatch('dialogConfirm', {
				title: 'Вы уверены?',
				message: 'Удалить заявку?'
			})
			.then(confirm => {
				if (confirm) {
					// console.log('delete')

					api.post('pr/delete', {
						id: this.pr.id
					})
					.then(response => {

						this.$router.push('/pr')

					}, error => {})
				}
			})
		},
		deleteQuotation(i) {
			// console.log('deleteQuotation', i)
			this.pr.qns.splice(i, 1)

			this.pr.qns.push({
				visible: false,
				name: '',
				// sumNet: '',
				sumGross: '',
				prepay: '',
				cash: false,
				deliveryBasis: '',
				deliveryDate: '',
				// deliveryCost: '',
			})

			this.pr.lines.forEach(line => {
				line.qns.splice(i, 1)

				line.qns.push({
					sumNet: 0
				})
			})

			this.pr.files.splice(i + 1, 1)
			this.files.splice(i + 1, 1)

			this.pr.files.push([])
			this.files.push([])
		},
		deliveryAdd() {
			this.pr.lines.push({
				num: this.pr.lines.length + 1,
				preOrderId: 0,
				postOrderId: 0,
				mmId: 0,
				mmLineId : 0,
				delivery: 1,
				name: 'Доставка',
				chars: '',
				unit: '',
				qty: '1',
				qns: [
					{
						sumNet: '',
						sumGross: ''
					},
					{
						sumNet: '',
						sumGross: ''
					},
					{
						sumNet: '',
						sumGross: ''
					}
				],
			})
		},
		drop() {
			this.startButtonLoading('drop')
			api.post('pr/drop', {
				id: this.pr.id,
			})
			.then(response => {

				this.stopButtonLoading('drop')
				this.pr.buttons = response.data.buttons
				this.pr.status = response.data.status
				this.pr.qnsSelectRequired = response.data.qnsSelectRequired
				this.pr.qnsListingRequired = response.data.qnsListingRequired

				this.loadComments()

				this.showSnackInfo(response.data.sysComment)

				this.$store.dispatch('loadMenuCounters')
			}, error => {
				this.stopButtonLoading('drop')
			})
		},
		dropToPu() {
			this.startButtonLoading('dropToPu')
			api.post('pr/drop_to_pu', {
				id: this.pr.id,
			})
			.then(response => {

				this.stopButtonLoading('dropToPu')
				this.pr.buttons = response.data.buttons
				this.pr.status = response.data.status
				this.pr.qnsSelectRequired = response.data.qnsSelectRequired
				this.pr.qnsListingRequired = response.data.qnsListingRequired

				this.loadComments()

				this.showSnackInfo(response.data.sysComment)

				this.$store.dispatch('loadMenuCounters')
			}, error => {
				this.stopButtonLoading('dropToPu')
			})
		},
		edit() {
			this.editMode = true
			this.showDetails = true
		},
		editIc() {
			this.editIcMode = true
			this.showDetails = true
		},
		editQns() {
			this.editQnsMode = true
			this.showDetails = true
		},
		getSteps() {
			// console.log('getSteps')

			var params

			if (this.viewMode) {
				params = {
					id: this.pr.id
				}
			}
			else {
				if (!this.pr.hotelCode) {
					return
				}
				params = {
					hotelCode: this.pr.hotelCode,
					type: this.pr.type,
					dc: this.pr.dc,
					ic: this.pr.ic,
					mmId: this.pr.mmId,
					qns: this.pr.qns.map((v, i) => {
						return Object.assign({ sumNet: this.qnsSumNet[i] }, v)
					})
				}
			}

			// console.log('load steps')
			api.post('pr/get_steps', params)
			.then(response => {

				this.pr.steps = response.data.data

			}, error => {})
		},
		getDcList() {
			// console.log('load dc list')

			api.post('common/get_dc', {
				pr: true,
			})
			.then(response => {

				this.lists.dc = response.data.data

			}, error => {})
		},
		getIcList() {
			if (!this.dc) return

			// console.log('load ic list')

			api.post('common/get_ic', {
				dc: this.dc,
				group: true,
				pr: true
			})
			.then(response => {

				this.lists.ic = response.data.data

			}, error => {})
		},
		getChartParams() {
			// console.log('getChartParams')

			var params

			if (this.viewMode) {
				params = {
					id: this.pr.id
				}
			}
			else {
				if (!this.pr.dc || !this.pr.ic || !this.deliveryDate || !this.hotelCode) {
					return
				}
				params = {
					dc: this.pr.dc,
					ic: this.pr.ic,
					deliveryDate: this.deliveryDate,
					hotelCode: this.hotelCode,
				}
			}

			// console.log('load chart params')
			api.post('pr/get_chart_params', params)
			.then(response => {

				this.pr.monthBudget = response.data.monthBudget
				this.pr.ytdBudget = response.data.ytdBudget
				this.pr.prFact = response.data.prFact
				this.pr.plFact = response.data.plFact

			}, error => {})
		},
		intersectButtons(entries, observer) {
			this.intersectingButtons = entries[0].isIntersecting
		},
		intersectComments(entries, observer) {
			this.intersectingComments = entries[0].isIntersecting
		},
		lineCopy(num) {
			let copy = _.cloneDeep(this.pr.lines[num - 1])
			copy.delivery = 0
			this.pr.lines.splice(num - 1, 0, copy)

			this.linesEnumerate()
		},
		lineAdd() {
			this.pr.lines.push({
				num: this.pr.lines.length + 1,
				preOrderId: 0,
				postOrderId: 0,
				mmId: 0,
				mmLineId : 0,
				delivery: 0,
				name: '',
				chars: '',
				unit: '',
				qty: '',
				qns: [
					{
						sumNet: '',
						sumGross: ''
					},
					{
						sumNet: '',
						sumGross: ''
					},
					{
						sumNet: '',
						sumGross: ''
					}
				],
			})
			this.$refs.form.resetValidation()
		},
		lineRemove(num) {
			this.pr.lines.splice(num - 1, 1)

			this.linesEnumerate()
		},
		lineUp(num) {
			// console.log('lineUp', num)
			let copy = this.pr.lines.splice(num - 1, 1)[0]
			this.pr.lines.splice(num - 2, 0, copy)

			this.linesEnumerate()
		},
		lineDown(num) {
			let copy = this.pr.lines.splice(num - 1, 1)[0]
			this.pr.lines.splice(num, 0, copy)

			this.linesEnumerate()
		},
		linesEnumerate() {
			for (let i = 0; i < this.pr.lines.length; i++) {
				this.pr.lines[i].num = i + 1
			}
		},
		load(loading) {
			let time = new Date
			// console.log(time.toTimeString().substr(0, 8), 'load')

			if (loading === undefined) loading = false

			this.loading = loading

			return api.post('pr/get_entry', {
				id: this.pr.id,
			})
			.then(response => {
				// console.log('load response')
				// console.log(response)

				if (this.viewMode && !this.order.show && response !== undefined) {
					this.pr = response.data.pr

					this.lists.dc = [
						{
							code: this.pr.dc,
							name: this.pr.dcn
						}
					]
					this.lists.ic = [
						{
							code: this.pr.ic,
							name: this.pr.icn
						}
					]
				}

				this.loading = false

			}, error => {})
		},
		loadComments() {
			if (this.$refs.comments) this.$refs.comments.load()
		},
		prepare() {
			// console.log('prepare')

			if (this.pr.id == 'new' && this.$route.params.mm === undefined) {
				this.pr.id = 0
				this.pr.authorName = this.$store.getters.userName
				this.pr.hotelCode = this.$store.getters.selectedHotelCode
				this.pr.status = 0
				this.showDetails = true
				this.editMode = true
				this.pr.mmId = 0

				let deliveryDate = new Date()
				deliveryDate.setDate(deliveryDate.getDate() + 5)
				this.pr.deliveryDate = deliveryDate.toISOString().substr(0, 10)

				this.debouncedGetSteps()

				this.lists.type.pop()

				return true
			}
			else if (this.pr.id == 'new' && this.$route.params.mm !== undefined) {
				console.log(this.$route.params.lines)

				this.pr.id = 0
				this.pr.authorName = this.$store.getters.userName
				this.pr.status = 0

				this.pr.title = 'Пополнение склада'
				this.pr.hotelCode = this.$route.params.mm.hotelCode
				this.pr.dc = +this.$route.params.mm.dc
				this.pr.type = 5
				this.pr.commentsA = 'Согласно ведомости мини-макс №' + this.$route.params.mm.id

				this.pr.mmId = this.$route.params.mm.id

				let deliveryDate = new Date()
				deliveryDate.setDate(deliveryDate.getDate() + 5)
				this.pr.deliveryDate = deliveryDate.toISOString().substr(0, 10)

				this.pr.lines = []

				let i = 1

				this.$route.params.lines.forEach(line => {
					this.pr.lines.push({
						num: i,
						preOrderId: 0,
						postOrderId: 0,
						mmId: this.$route.params.mm.id,
						mmLineId: line.id,
						delivery: 0,
						name: line.name,
						chars: line.chars,
						unit: line.unit,
						qty: line.qtyOrder,
						qns: [
							{
								sumNet: toStr(toNum(line.priceNetOrder) * toNum(line.qtyOrder)),
								sumGross: ''
							},
							{
								sumNet: '',
								sumGross: ''
							},
							{
								sumNet: '',
								sumGross: ''
							}
						],
					})
					i++
				})

				this.showDetails = true
				this.editMode = true

				this.debouncedGetSteps()

				return true
			}
			else {
				this.pr.id = +this.pr.id
				return this.load(true)
			}
		},
		reject() {
			this.startButtonLoading('reject')
			api.post('pr/reject', {
				id: this.pr.id,
			})
			.then(response => {

				this.stopButtonLoading('reject')
				this.pr.buttons = response.data.buttons
				this.pr.status = response.data.status
				this.pr.qnsSelectRequired = response.data.qnsSelectRequired
				this.pr.qnsListingRequired = response.data.qnsListingRequired

				this.loadComments()

				this.showSnackInfo(response.data.sysComment)

				this.$store.dispatch('loadMenuCounters')
			}, error => {
				this.stopButtonLoading('reject')
			})
		},
		payrollSetTax(val) {
			this.$refs.totalPayroll.percentChange(val)
		},
		print() {
			let originalShowDetails = this.showDetails
			this.showDetails = true

			this.$emit('print')
			this.topMenu = false

			this.showDetails = originalShowDetails
		},
		qSelect(e, i) {
			if (e) {
				this.qSelected = i
			}
			else {
				this.qSelected = 0
			}
		},
		startButtonLoading(value) {
			this.pr.buttons.find(b => b.value == value).loading = true
		},
		stopButtonLoading(value) {
			this.pr.buttons.find(b => b.value == value).loading = false
		},
		submitEditing(approve) {
			if (!this.$refs.form.validate()) {
				this.showErrors = true
				this.$vuetify.goTo(0)
				return
			}

			// console.log('submitEditing')
			this.loading = true

			var formData = new FormData()

			for (let i = 0; i < 4; i++) {
				let l = this.files[i].length
				for (let j = 0; j < l; j++) {
					// console.log(i, j, this.files[i][j])
					formData.append(`files_${i}[]`, this.files[i][j])
				}
			}

			formData.append('form', JSON.stringify({
				pr: _.pick(this.pr, [
					'id',
					'hotelCode',
					'budget',
					'dc',
					'ic',
					'title',
					'type',
					'mmId',
					'deliveryDate',
					'urgent',
					'lines',
					'files',
					'uniqueSupplier',
					'qSelected',
					'qns',
					'commentsA',
					'commentsB'
				]),
				qnsCount: this.qnsCount,
				approve: approve
			}))

			api.post('pr/change', formData)
			.then(response => {

				this.editMode = false
				this.editQnsMode = false
				this.editIcMode = false
				this.showErrors = false

				if (this.pr.id == 0) {
					this.$router.push({ path: '/pr/' + response.data.id })
				}
				else {
					this.pr.buttons = response.data.buttons
					this.files.forEach(f => {
						f.splice(0, f.length)
					})
					if (response.data.files) {
						this.pr.files = response.data.files
					}
					this.pr.qnsSelectRequired = response.data.qnsSelectRequired
					this.pr.qnsListingRequired = response.data.qnsListingRequired
					this.pr.status = response.data.status
				}

				this.loading = false

			}, error => {
				this.loading = false
			})
		},
		toStr(val, dec) {
			return toStr(val, dec)
		},
		toNum(val, dec) {
			return toNum(val, dec)
		},
		withdraw() {
			this.startButtonLoading('withdraw')
			api.post('pr/withdraw', {
				id: this.pr.id,
			})
			.then(response => {

				this.stopButtonLoading('withdraw')
				this.pr.buttons = response.data.buttons
				this.pr.status = response.data.status
				this.pr.qnsSelectRequired = response.data.qnsSelectRequired
				this.pr.qnsListingRequired = response.data.qnsListingRequired

				this.loadComments()

				this.showSnackInfo(response.data.sysComment)

				this.$store.dispatch('loadMenuCounters')
			}, error => {
				this.stopButtonLoading('withdraw')
			})
		},
	},
	beforeRouteUpdate (to, from, next) {
		// console.log('beforeRouteUpdate')

		if (to.params.id != 'new') {
			if (this.editMode) {
				this.editMode = false
				var editMode = true
			}

			this.pr.id = to.params.id

			this.prepare().then(response => {
				if (editMode) this.editMode = true
			})

			next()
		}

		this.draftMode = to.params.draftMode
	},
}
